/* eslint-disable max-len */
import React from 'react';

export default function UploadIcon(props) {
  return (
    <svg viewBox="0 0 7 8" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 6.118h3V3.294h2L3.5 0 0 3.294h2v2.824zm-2 .94h7V8H0v-.941z" />
    </svg>
  );
}
